export const TYPE = {
    CART_LIST: 'CART_LIST',
    SET_LOADER: 'SET_LOADER'
}